"use client";

import { useState } from "react";
import { motion } from "framer-motion";

// type PromptCategoryProps = {
//   category: string;
//   prompts: {
//     text: string;
//     icon: string;
//   }[];
//   onPromptClick: (text: string) => void;
//   isLoading: boolean;
// };

export function TravelPromptSuggestions({
  onPromptClick,
  isLoading,
}: {
  onPromptClick: (text: string) => void;
  isLoading: boolean;
}) {
  const [activeCategory, setActiveCategory] = useState("popular");

  const categories = {
    popular: [
      { text: "Create a 3-day itinerary for Paris", icon: "🗼" },
      { text: "Suggest budget-friendly destinations in Europe", icon: "💰" },
      { text: "Best places to visit in Japan during spring", icon: "🌸" },
      { text: "Family-friendly activities in London", icon: "👨‍👩‍👧‍👦" },
    ],
    itineraries: [
      { text: "Plan a 2-day foodie trip to Tokyo", icon: "🍣" },
      { text: "Create a 5-day adventure trip in Costa Rica", icon: "🌴" },
      { text: "Weekend itinerary for New York City", icon: "🗽" },
      { text: "7-day road trip along California coast", icon: "🚗" },
    ],
    recommendations: [
      { text: "Recommend places with best beaches in November", icon: "🏖️" },
      { text: "Suggest romantic destinations for honeymoon", icon: "💑" },
      { text: "Best cities for digital nomads in Asia", icon: "💻" },
      { text: "Off-the-beaten-path destinations in Europe", icon: "🧭" },
    ],
    tips: [
      { text: "Tips for solo female travelers", icon: "👩" },
      { text: "How to manage jet lag on long flights", icon: "✈️" },
      { text: "Packing tips for winter destinations", icon: "🧳" },
      { text: "Safety tips for traveling in South America", icon: "🛡️" },
    ],
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-4 mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">
        Travel Inspirations
      </h3>

      {/* Category tabs */}
      <div className="flex mb-4 border-b border-gray-200 overflow-x-auto no-scrollbar ">
        {Object.keys(categories).map((category) => (
          <button
            key={category}
            className={`px-4 py-2 text-sm font-medium whitespace-nowrap hover:cursor-pointer transition-all ${
              activeCategory === category
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setActiveCategory(category)}
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div>

      {/* Prompt grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {categories[activeCategory as keyof typeof categories].map(
          (prompt, index) => (
            <motion.button
              key={index}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => onPromptClick(prompt.text)}
              disabled={isLoading}
              className="flex items-center p-3 rounded-lg text-left transition-all bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 hover:cursor-pointer border border-blue-100 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <span className="text-xl mr-2">{prompt.icon}</span>
              <span className="text-sm text-gray-700">{prompt.text}</span>
            </motion.button>
          )
        )}
      </div>
    </div>
  );
}
